export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19.288 3.5A2.502 2.502 0 0 0 17 2H7a2.993 2.993 0 0 0-2.583 1.5H2v1h2.051A2.942 2.942 0 0 0 4 5v17h10.5l.5-.037V17.5h4l.5-.5V4.5H22v-1h-2.712ZM17 3c.442 0 .835.195 1.11.5h-2.878a2.8 2.8 0 0 1 .231-.5H17ZM5 5c0-1.103.897-2 2-2h7.339C14.114 3.567 14 4.236 14 5v7.5H5V5Zm9 8.5v1H5v-1h9ZM5 21v-5.5h9v5.457L5 21Zm13.5-4.5H15V5c0-.176.014-.338.027-.5H18.5v12Z"
    />
  </svg>
);
